module.exports = __webpack_public_path__ + "media/lifesum-intro-se-2adeb1ef.mp4";